;(function() {
  'use strict'

  angular.module('glow.reporting').component('surveyExplorerWeightingDialog', {
    controller: Controller,
    templateUrl: 'survey-explorer-weighting-dialog.html',
    bindings: {
      dashboard: '<',
      isShared: '<',
      onApply: '&',
      onCancel: '&',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.isDisabled = isDisabled
    ctrl.toggle = toggle
    ctrl.add = add
    ctrl.remove = remove
    ctrl.apply = apply
    ctrl.cancel = cancel

    function onInit() {
      ctrl.weightScheme = ctrl.dashboard.weightScheme.clone()
      ctrl.filterOptions = ctrl.dashboard.filters.map(function(filter) {
        return { label: filter.name, value: filter.id }
      })
      ctrl.isToggleDisabled =
        !ctrl.weightScheme.enabled &&
        (ctrl.dashboard.marginOfError.enabled ||
          ctrl.dashboard.significanceTest.enabled)
    }

    function isDisabled() {
      return !ctrl.weightScheme.enabled || ctrl.dashboard.readOnly
    }

    function toggle() {
      if (ctrl.isToggleDisabled) return
      ctrl.weightScheme.enabled = !ctrl.weightScheme.enabled
    }

    function add() {
      ctrl.weightScheme.addWeightRule()
    }

    function remove(idx) {
      ctrl.weightScheme.removeWeightRule(idx)
    }

    function apply() {
      if (!ctrl.weightScheme.validate(ctrl.dashboard.filters)) {
        return
      }
      ctrl.dashboard.weightScheme.copy(ctrl.weightScheme)
      ctrl.onApply()
    }

    function cancel() {
      ctrl.onCancel()
    }
  }
})()
